import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overview-metrics" }
const _hoisted_2 = { class: "metric-block" }
const _hoisted_3 = { class: "block-hd" }
const _hoisted_4 = { class: "block-title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "handlers-container" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, "ICCID", -1)

import useI18nTl from '@/hooks/useI18nTl'
import { dateFormat, throttleBtn } from '@/common/tools'
import LinkStation from '@/components/Links/LinkStation.vue'
import LinkOperator from '@/components/Links/LinkOperator.vue'
import EvseStatus from '@/components/EvseStatus.vue'
import EvseOperationType from '@/components/EvseOperationType.vue'
import LinkEvse from '@/components/Links/LinkEvse.vue'

import { computed, defineComponent, defineProps } from 'vue'

const __default__ = defineComponent({
  name: 'EvseInfo',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  evse: {
    type: Object,
  },
},
  setup(__props) {

const props = __props

const { t } = useI18nTl('Operation')



return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('Evses.evseInfo')), 1),
        _hoisted_5
      ]),
      _createVNode(_component_el_descriptions, {
        class: "margin-top",
        column: 6,
        direction: "vertical",
        border: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('Evses.state')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(EvseStatus, {
                state: __props.evse?.state
              }, null, 8, ["state"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('Evses.id')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(LinkEvse, {
                id: __props.evse?.id,
                name: __props.evse?.id
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('Evses.stationName')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(LinkStation, {
                id: __props.evse?.stationID,
                name: __props.evse?.stationName
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('Evses.operatorName')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(LinkOperator, {
                id: __props.evse?.operatorID,
                name: __props.evse?.operatorName
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('Evses.operationType')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(EvseOperationType, {
                type: __props.evse?.evseOperationType
              }, null, 8, ["type"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('Evses.ratedPower') +
                '/' +
                _ctx.$t('Evses.ratedVoltage') +
                '/' +
                _ctx.$t('Evses.ratedCurrent')), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(`${__props.evse?.evseModel?.ratedPower}W / ${__props.evse?.evseModel?.ratedVoltage}V / ${__props.evse?.evseModel?.ratedCurrentMax}A`), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('Evses.protocolVersion')), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(__props.evse?.protocolVersion), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('Evses.firmwareVersion')), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(__props.evse?.firmwareVersion), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(__props.evse?.iccid), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('Evses.lastBootTime')), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(__props.evse?.lastBootTime ?? _unref(dateFormat)(Number(__props.evse?.lastBootTime) * 1000)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('Evses.lastDisconnectReason')), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(__props.evse?.lastDisconnectReason), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('Evses.createdAt')), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_unref(dateFormat)(Number(__props.evse?.createdAt) * 1000)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})